(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-product"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {


    /* =========================================
       NUMBER OF GUESTS / VARIANT BUTTONS
       ========================================= */

    const variantButtons =
      document.querySelectorAll(
        '.service-product__variant-pill[data-variant-id]'
      );

    const variantInput =
      document.getElementById(
        'ServiceVariant'
      );

    const variantIdInput =
      document.getElementById(
        'ServiceVariantId'
      );


    variantButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          variantButtons.forEach(
            function (otherButton) {

              otherButton.classList.remove(
                'is-selected'
              );

              otherButton.setAttribute(
                'aria-pressed',
                'false'
              );

            }
          );


          button.classList.add(
            'is-selected'
          );

          button.setAttribute(
            'aria-pressed',
            'true'
          );


          if (variantInput) {

            variantInput.value =
              button.getAttribute(
                'data-variant-title'
              ) || '';

          }


          if (variantIdInput) {

            variantIdInput.value =
              button.getAttribute(
                'data-variant-id'
              ) || '';

          }

        }
      );

    });


    /* =========================================
       COLLECTION / LOCAL DELIVERY
       ========================================= */

    const fulfilmentButtons =
      document.querySelectorAll(
        '.service-product__fulfilment-pill'
      );

    const fulfilmentInput =
      document.getElementById(
        'ServiceFulfilment'
      );


    fulfilmentButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            fulfilmentButtons.forEach(
              function (otherButton) {

                otherButton.classList.remove(
                  'is-selected'
                );

                otherButton.setAttribute(
                  'aria-pressed',
                  'false'
                );

              }
            );


            button.classList.add(
              'is-selected'
            );

            button.setAttribute(
              'aria-pressed',
              'true'
            );


            if (fulfilmentInput) {

              fulfilmentInput.value =
                button.getAttribute(
                  'data-fulfilment'
                ) || '';

            }

          }
        );

      }
    );


    /* =========================================
       DATE
       ========================================= */

    const dateInput =
      document.getElementById(
        'ServiceDate'
      );


    /* =========================================
       CUSTOM TIME PICKER
       ========================================= */

    const timePicker =
      document.getElementById(
        'ServiceTimePicker'
      );

    const timeTrigger =
      document.getElementById(
        'ServiceTimeTrigger'
      );

    const timeDisplay =
      document.getElementById(
        'ServiceTimeDisplay'
      );

    const timeInput =
      document.getElementById(
        'ServiceTime'
      );

    const timeOptions =
      document.querySelectorAll(
        '.service-product__time-option'
      );

    const form =
      document.getElementById(
        'ServiceEnquiryForm'
      );


    if (
      !dateInput ||
      !timePicker ||
      !timeTrigger ||
      !timeInput
    ) {

      return;

    }


    /* =========================================
       DATE FORMAT
       ========================================= */

    function formatDate(date) {

      const year =
        date.getFullYear();

      const month =
        String(
          date.getMonth() + 1
        ).padStart(2, '0');

      const day =
        String(
          date.getDate()
        ).padStart(2, '0');

      return (
        year +
        '-' +
        month +
        '-' +
        day
      );

    }


    /* =========================================
       12-HOUR MINIMUM
       ========================================= */

    function getEarliestDateTime() {

      const earliest =
        new Date();

      earliest.setTime(
        earliest.getTime() +
        (12 * 60 * 60 * 1000)
      );

      return earliest;

    }


    /* =========================================
       UPDATE MINIMUM DATE
       ========================================= */

    function updateDateLimit() {

      const earliest =
        getEarliestDateTime();

      dateInput.min =
        formatDate(earliest);

    }


    /* =========================================
       TIME TO MINUTES
       ========================================= */

    function timeToMinutes(time) {

      const parts =
        time.split(':');

      return (
        (Number(parts[0]) * 60) +
        Number(parts[1])
      );

    }


    /* =========================================
       FORMAT TIME FOR DISPLAY
       ========================================= */

    function formatDisplayTime(time) {

      const parts =
        time.split(':');

      let hours =
        Number(parts[0]);

      const minutes =
        parts[1];

      const suffix =
        hours >= 12
          ? 'PM'
          : 'AM';


      if (hours === 0) {

        hours = 12;

      } else if (hours > 12) {

        hours -= 12;

      }


      return (
        hours +
        ':' +
        minutes +
        ' ' +
        suffix
      );

    }


    /* =========================================
       GET SELECTED DATE / TIME
       ========================================= */

    function getSelectedDateTime() {

      if (
        !dateInput.value ||
        !timeInput.value
      ) {

        return null;

      }


      const dateParts =
        dateInput.value.split('-');

      const timeParts =
        timeInput.value.split(':');


      if (
        dateParts.length !== 3 ||
        timeParts.length < 2
      ) {

        return null;

      }


      return new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2]),
        Number(timeParts[0]),
        Number(timeParts[1]),
        0,
        0
      );

    }


    /* =========================================
       UPDATE AVAILABLE TIME OPTIONS
       ========================================= */

    function updateTimeOptions() {

      const earliest =
        getEarliestDateTime();

      const selectedDate =
        dateInput.value;


      if (!selectedDate) {

        timeOptions.forEach(
          function (option) {

            option.disabled = false;

          }
        );

        return;

      }


      const earliestDate =
        formatDate(earliest);


      if (
        selectedDate !== earliestDate
      ) {

        timeOptions.forEach(
          function (option) {

            option.disabled = false;

          }
        );

        return;

      }


      const minimumMinutes =
        (
          earliest.getHours() * 60
        ) +
        earliest.getMinutes();


      timeOptions.forEach(
        function (option) {

          const optionTime =
            option.getAttribute(
              'data-time'
            );

          const optionMinutes =
            timeToMinutes(
              optionTime
            );


          if (
            optionMinutes <
            minimumMinutes
          ) {

            option.disabled = true;

          } else {

            option.disabled = false;

          }

        }
      );


      if (timeInput.value) {

        const selectedMinutes =
          timeToMinutes(
            timeInput.value
          );


        if (
          selectedMinutes <
          minimumMinutes
        ) {

          clearSelectedTime();

        }

      }

    }


    /* =========================================
       CLEAR SELECTED TIME
       ========================================= */

    function clearSelectedTime() {

      timeInput.value = '';

      timeDisplay.textContent =
        'Select a time';

      timeDisplay.classList.add(
        'service-product__time-placeholder'
      );


      timeOptions.forEach(
        function (option) {

          option.classList.remove(
            'is-selected'
          );

          option.setAttribute(
            'aria-selected',
            'false'
          );

        }
      );

    }


    /* =========================================
       SELECT TIME
       ========================================= */

    function selectTime(time) {

      const option =
        document.querySelector(
          '.service-product__time-option[data-time="' +
          time +
          '"]'
        );


      if (
        !option ||
        option.disabled
      ) {

        return;

      }


      timeInput.value =
        time;


      timeDisplay.textContent =
        formatDisplayTime(time);


      timeDisplay.classList.remove(
        'service-product__time-placeholder'
      );


      timeOptions.forEach(
        function (otherOption) {

          otherOption.classList.remove(
            'is-selected'
          );

          otherOption.setAttribute(
            'aria-selected',
            'false'
          );

        }
      );


      option.classList.add(
        'is-selected'
      );

      option.setAttribute(
        'aria-selected',
        'true'
      );


      closeTimePicker();

    }


    /* =========================================
       OPEN TIME PICKER
       ========================================= */

    function openTimePicker() {

      updateTimeOptions();

      timePicker.classList.add(
        'is-open'
      );

      timeTrigger.setAttribute(
        'aria-expanded',
        'true'
      );

    }


    /* =========================================
       CLOSE TIME PICKER
       ========================================= */

    function closeTimePicker() {

      timePicker.classList.remove(
        'is-open'
      );

      timeTrigger.setAttribute(
        'aria-expanded',
        'false'
      );

    }


    /* =========================================
       TIME TRIGGER
       ========================================= */

    timeTrigger.addEventListener(
      'click',
      function () {

        if (
          timePicker.classList.contains(
            'is-open'
          )
        ) {

          closeTimePicker();

        } else {

          openTimePicker();

        }

      }
    );


    /* =========================================
       TIME OPTIONS
       ========================================= */

    timeOptions.forEach(
      function (option) {

        option.addEventListener(
          'click',
          function () {

            if (option.disabled) {
              return;
            }


            const time =
              option.getAttribute(
                'data-time'
              );


            selectTime(time);

          }
        );

      }
    );


    /* =========================================
       DATE CHANGED
       ========================================= */

    dateInput.addEventListener(
      'change',
      function () {

        updateDateLimit();

        updateTimeOptions();

      }
    );


    /* =========================================
       OPEN DATE PICKER
       ========================================= */

    dateInput.addEventListener(
      'click',
      function () {

        if (
          typeof dateInput.showPicker ===
          'function'
        ) {

          try {

            dateInput.showPicker();

          } catch (error) {

            /*
             * Browser has already opened
             * the native calendar.
             */

          }

        }

      }
    );


    /* =========================================
       CLOSE TIME PICKER OUTSIDE CLICK
       ========================================= */

    document.addEventListener(
      'click',
      function (event) {

        if (
          !timePicker.contains(
            event.target
          )
        ) {

          closeTimePicker();

        }

      }
    );


    /* =========================================
       ESCAPE KEY
       ========================================= */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape'
        ) {

          closeTimePicker();

        }

      }
    );


    /* =========================================
       FORM SUBMISSION VALIDATION
       ========================================= */

    if (form) {

      form.addEventListener(
        'submit',
        function (event) {


          /* -------------------------------
             CHECK FULFILMENT
             ------------------------------- */

          if (
            !fulfilmentInput ||
            !fulfilmentInput.value
          ) {

            event.preventDefault();

            alert(
              'Please select Collection or Local Delivery.'
            );

            return;

          }


          /* -------------------------------
             CHECK TIME
             ------------------------------- */

          if (!timeInput.value) {

            event.preventDefault();

            openTimePicker();

            alert(
              'Please select a preferred time.'
            );

            return;

          }


          /* -------------------------------
             CHECK DATE
             ------------------------------- */

          if (!dateInput.value) {

            event.preventDefault();

            alert(
              'Please select a preferred date.'
            );

            return;

          }


          const selectedDateTime =
            getSelectedDateTime();

          const earliestDateTime =
            getEarliestDateTime();


          if (!selectedDateTime) {

            event.preventDefault();

            alert(
              'Please select a valid date and time.'
            );

            return;

          }


          /* -------------------------------
             12-HOUR CHECK
             ------------------------------- */

          if (
            selectedDateTime.getTime() <
            earliestDateTime.getTime()
          ) {

            event.preventDefault();

            clearSelectedTime();

            updateTimeOptions();

            openTimePicker();

            alert(
              'Please choose a date and time that is at least 12 hours from now.'
            );

            return;

          }


          /* -------------------------------
             30-MINUTE CHECK
             ------------------------------- */

          const minutes =
            selectedDateTime.getMinutes();


          if (
            minutes !== 0 &&
            minutes !== 30
          ) {

            event.preventDefault();

            clearSelectedTime();

            openTimePicker();

            alert(
              'Please choose a time in 30-minute intervals.'
            );

            return;

          }

        }
      );

    }


    /* =========================================
       INITIALISE
       ========================================= */

    updateDateLimit();

    updateTimeOptions();


    /* =========================================
       KEEP DATE LIMIT CURRENT
       ========================================= */

    setInterval(
      function () {

        updateDateLimit();

        updateTimeOptions();

      },
      60000
    );

  });


  } catch(e) { console.error(e); }
})();
})();
